import moment from "moment-timezone";

export function Time__Minutes(time: string): number {
  const date = moment.utc(time, "HH:mm");
  return date.minutes() + date.hours() * 60;
}
